/* dzc-header.js — Drawlz native header interaction.

   The header, the trigger row and the DEFAULT state of every panel (including
   its image plate) are server-rendered by sections/dzc-header.liquid. This file
   never builds the nav. What it does:

     - scroll state: logo morph at >40px, black background at end-of-hero
     - panel open/close, hover intent, Escape, scrim, auto-close on pointer-leave
     - swapping the image plate as you hover a link (image + caption + LINK all
       change together, then snap back to the panel default on leave)
     - the mobile accordion drawer

   The plate is the one piece that is client-rendered, because it swaps on
   hover. That is safe: it lives inside a closed panel, so nothing it does can
   ever be visible during first paint. Its default markup is still server-
   rendered so the panel is correct and clickable before this file runs.

   Backslash-free on purpose - see the handoff traps. */
/* ===========================================================================
   CART BOOT — runs on every page, BEFORE and independently of the nav wiring.

   THE BUG THIS FIXES (launch blocker): content_for_footer.liquid defers ~20
   scripts — including global.min.js, cart.js, cart-drawer.js and
   product-form.js — behind the visitor's FIRST INTERACTION. But the first
   interaction is very often the click that needs them: tap the cart icon or
   Add to cart on a fresh page and the custom elements are not defined yet, so
   nothing intercepts and the browser follows the href / native POST straight
   to /cart. Guaranteed on mobile, where there is no mousemove to wake the
   loader early. Verified: after any interaction everything upgrades correctly
   and the drawer opens — so the wiring was never wrong, only the timing.

   Fix, in two parts:
     1. Promote just the cart-critical chain to real `src` immediately, IN
        ORDER. Order matters: cart-drawer.js subclasses CartItems from cart.js,
        and promoted scripts execute on load, not in document order (the same
        race that produced "SearchForm is not defined").
     2. A capture-phase guard on the cart icon, so a click landing inside the
        remaining download window still opens the drawer instead of navigating.

   The other ~15 lazy scripts are left alone; this is deliberately the smallest
   set that makes add-to-cart, the drawer AND THE SIZE PICKER reliable.

   WHY pickup-availability.js IS IN THIS CHAIN (2026-08-10). It looks unrelated
   to the cart, and it is — but leaving it out silently broke variant selection
   on every Dawn PDP, on the draft AND on live. Dawn's onVariantChange() runs a
   fixed sequence:

     updateOptions -> updateMasterId -> toggleAddButton -> updatePickupAvailability
     -> ... -> updateVariantInput

   updatePickupAvailability() guards only on the <pickup-availability> ELEMENT
   existing, never on it having been upgraded. With the script still lazy the
   element is present but inert, so that line throws
   "pickUpAvailability.fetchAvailability is not a function" and every step after
   it is abandoned — including updateVariantInput(), which is the one that
   writes the chosen variant into the cart form.

   Shopper-visible result: the size button visually selected 3XL while the form
   still held S, the URL never updated, and Add to Cart added S. The click that
   triggered it is also the click that wakes the lazy loader, so the SECOND
   click worked — which is exactly why it read as random customer error and
   survived to production. Measured window: ~1.1s from first interaction.

   Verified before the edit by promoting this one file at runtime on a cold PDP
   and clicking a size as the first interaction: form moved S -> 3XL, URL
   updated, zero console errors. Position matters only in that it must come
   after global.min.js (it calls trapFocus / removeTrapFocus); it is 3,952 bytes.
   ======================================================================== */
(function () {
  'use strict';

  var CHAIN = ['global.min.js', 'pickup-availability.js', 'cart.js', 'cart-drawer.js', 'product-form.js', 'quantity-popover.js'];

  function findLazy(name) {
    var tags = document.querySelectorAll('script[data-src]');
    for (var i = 0; i < tags.length; i++) {
      var ds = tags[i].getAttribute('data-src') || '';
      if (ds.indexOf(name) !== -1 && !tags[i].getAttribute('src')) return tags[i];
    }
    return null;
  }

  function promoteInOrder(list, done) {
    var i = 0;
    (function next() {
      if (i >= list.length) { if (done) done(); return; }
      var tag = findLazy(list[i++]);
      if (!tag) { next(); return; }
      tag.addEventListener('load', next, { once: true });
      tag.addEventListener('error', next, { once: true });
      tag.setAttribute('src', tag.getAttribute('data-src'));
    })();
  }

  /* The search overlay at the bottom of this file wakes predictive-search.js the same
     way. Exposed rather than duplicated so there is one definition of "promote these
     lazy scripts, in order, and skip any already loaded". */
  window.dzcPromote = promoteInOrder;

  function ready() { var cd = document.querySelector('cart-drawer'); return !!(cd && typeof cd.open === 'function'); }

  /* Guard the cart icon during the download window. Capture phase so it runs
     before the theme's own handler exists; it steps aside as soon as the drawer
     is live, and hard-falls back to navigating if the scripts never arrive. */
  function guardCartIcon() {
    document.addEventListener('click', function (e) {
      var icon = e.target && e.target.closest && e.target.closest('#cart-icon-bubble');
      if (!icon || ready()) return;
      e.preventDefault();
      e.stopPropagation();
      var waited = 0;
      var t = setInterval(function () {
        waited += 60;
        if (ready()) {
          clearInterval(t);
          var cd = document.querySelector('cart-drawer');
          try { cd.open(icon); } catch (err) { window.location.href = icon.getAttribute('href') || '/cart'; }
        } else if (waited > 2500) {
          clearInterval(t);
          window.location.href = icon.getAttribute('href') || '/cart';
        }
      }, 60);
    }, true);
  }

  function boot() { guardCartIcon(); promoteInOrder(CHAIN); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

(function () {
  'use strict';

  var wrap = document.querySelector('[data-dzc-wrap]');
  if (!wrap || wrap.dataset.dzcWired) return;
  wrap.dataset.dzcWired = '1';

  var header = wrap.querySelector('[data-dzc-header]');
  var panels = wrap.querySelector('[data-dzc-panels]');
  var scrim = document.querySelector('[data-dzc-scrim]');
  var items = [].slice.call(wrap.querySelectorAll('[data-dzc-item]'));

  /* ------------------------------------------------------------- data ---- */
  var CONFIG = {};
  try {
    var node = document.getElementById('dzc-nav-data');
    if (node) CONFIG = JSON.parse(node.textContent || '{}');
  } catch (e) { CONFIG = {}; }

  /* ----------------------------------------------------------- scroll ----
     Two INDEPENDENT thresholds, per the brief: the wordmark morphs into the D
     as soon as you scroll, but the background only goes black once the hero
     has left. On templates with no hero the section marks the wrap opaque and
     we skip the transparent state entirely. */
  var opaque = wrap.classList.contains('dzc-hdrwrap--opaque');
  /* Hero detection. NOT simply the first .shopify-section: on this store the
     first section is a short utility strip, which made pastHero true at scroll
     0 and the bar went black instantly instead of sitting over the hero. Take
     the first section in the first few that is actually hero-sized (>=55% of
     the viewport). If nothing qualifies, there is no hero to be transparent
     over, so behave as opaque. */
  var hero = document.querySelector('[data-dzc-hero]');
  if (!hero && !opaque) {
    var main = document.getElementById('MainContent') || document.body;
    var secs = main.querySelectorAll('.shopify-section');
    var need = window.innerHeight * 0.55;
    for (var s = 0; s < secs.length && s < 4; s++) {
      if (secs[s].offsetHeight >= need) { hero = secs[s]; break; }
    }
    if (!hero) opaque = true;
  }
  var menuOpen = false;

  function syncHeader() {
    var y = window.scrollY || window.pageYOffset || 0;
    var scrolled = y > 40;
    var pastHero = opaque ? true : (hero ? y > (hero.offsetHeight - 140) : scrolled);
    header.classList.toggle('is-small', scrolled);
    wrap.classList.toggle('is-small', scrolled);
    header.classList.toggle('is-solid', opaque || pastHero || menuOpen);
  }

  /* ------------------------------------------------------------ panels --- */
  var closeTimer = null;
  var activePanel = null;

  function open(name) {
    clearTimeout(closeTimer);
    /* Reopening is the ONLY reset point: the panel always starts on the
       placeholder, then the last hovered item sticks until it is reopened. */
    var wasOpen = menuOpen && activePanel === name;
    menuOpen = true;
    activePanel = name;
    if (!wasOpen) { cancelRevert(); renderHero(name); }
    items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-dzc-item') === name); });
    var t = wrap.querySelectorAll('[data-dzc-panel]');
    for (var i = 0; i < t.length; i++) {
      var on = t[i].getAttribute('data-dzc-panel') === name;
      t[i].classList.toggle('is-open', on);
      var btn = items.filter(function (x) { return x.getAttribute('data-dzc-item') === t[i].getAttribute('data-dzc-panel'); })[0];
      if (btn) { var b = btn.querySelector('.dzc-trigger'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false'); }
    }
    if (scrim) scrim.classList.add('is-show');
    syncHeader();
    if (window.DZC_COSMOS) window.DZC_COSMOS.mount(wrap);
  }

  function close() {
    menuOpen = false;
    activePanel = null;
    items.forEach(function (it) {
      it.classList.remove('is-active');
      var b = it.querySelector('.dzc-trigger');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    var t = wrap.querySelectorAll('[data-dzc-panel]');
    for (var i = 0; i < t.length; i++) t[i].classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-show');
    syncHeader();
  }

  items.forEach(function (it) {
    var name = it.getAttribute('data-dzc-item');
    it.addEventListener('mouseenter', function () { open(name); });
    var btn = it.querySelector('.dzc-trigger');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (it.classList.contains('is-active')) { close(); } else { open(name); }
      });
    }
  });

  /* Auto-close the instant the pointer leaves — no click-to-dismiss, no trap. */
  wrap.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 80); });
  wrap.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
  if (scrim) {
    scrim.addEventListener('mouseenter', close);
    scrim.addEventListener('click', close);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ------------------------------------------------------- plate render ---
     Mirrors the mock's renderer. Images are background-image so a swap never
     shows a half-loaded <img>, and every sub-cell is an independent link. */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function bg(src) {
    return src ? ' style="background-image:url(' + encodeURI(src).replace(/[()]/g, '\\$&') + ')"' : '';
  }
  /* Coded graphics are cloned from a <template> the section emits. Both are
     CSS-only; an inline <style> applies when inserted via innerHTML, an inline
     <script> would not run — so neither snippet may ever grow one. */
  var GRAPHIC_TPL = { cosmos: 'dzc-cosmos-tpl', finalcut: 'dzc-finalcut-tpl', statement: 'dzc-statement-tpl' };
  function graphicHTML(name) {
    var id = GRAPHIC_TPL[name];
    if (!id) return '';
    var tpl = document.getElementById(id);
    return tpl ? tpl.innerHTML : '';
  }
  /* One image slot. A `graphic` REPLACES slot 1's artwork entirely. An empty
     src with no graphic falls through to the neutral placeholder — images are
     MANUAL (v2), so nothing is ever substituted from the catalogue. */
  function art(entry, cls, graphic) {
    var gfx = graphicHTML(graphic);
    var src = gfx ? '' : ((entry && entry.src) || '');
    var ph = (!src && !gfx) ? ' dzc-ph' : '';
    /* dzc-pv--gfx cancels the slow scale(1.05) photo drift. That drift is right
       for photography but it was also enlarging the coded graphics' typography
       past the size they were designed at. */
    var g = gfx ? ' dzc-pv--gfx' : '';
    return '<div class="' + cls + ' dzc-g-default' + ph + g + '"' + bg(src) + '>' + gfx + '</div>';
  }
  function imgAt(it, n) {
    var a = it.imgs || [];
    return a[n] || { src: '', href: it.href || '#' };
  }
  function cell(it, n, mod) {
    var e = imgAt(it, n);
    var href = e.href || it.href || '#';
    return '<a class="dzc-cell ' + (mod || '') + '" href="' + esc(href) + '">' +
      art(e, 'dzc-cimg', n === 0 ? it.graphic : null) +
      '<span class="dzc-clab">' + esc(it.name) + '</span>' +
      '<span class="dzc-ccta"><span>Shop ' + esc(it.name) + '</span></span></a>';
  }

  function render(panelName, key) {
    var P = CONFIG[panelName]; if (!P) return;
    var it = P.items[key] || P.items[P.fallbackKey];
    if (!it) return;
    var plate = wrap.querySelector('.dzc-plate[data-dzc-plate="' + panelName + '"]');
    if (!plate) return;

    /* Nothing uploaded and no coded graphic -> collapse the image area rather
       than showing an empty placeholder panel. */
    if (!hasMedia(it)) { renderPlaceholder(panelName); return; }
    setMedia(panelName, true);

    var layout = it.layout || 'single';

    /* v2: the cells come from THIS item's own image_1..4, not from sibling
       items. Each slot carries its own link, falling back to the item's link. */
    var html = '';
    if (layout === 'hero2') {
      html = '<div class="dzc-lay dzc-lay-tri">' + cell(it, 0, 'dzc-cell--big') + cell(it, 1, 'dzc-cell--sq') + cell(it, 2, 'dzc-cell--sq') + '</div>';
    } else if (layout === 'duo') {
      html = '<div class="dzc-lay dzc-lay-two">' + cell(it, 0) + cell(it, 1) + '</div>';
    } else if (layout === 'quad') {
      html = '<div class="dzc-lay dzc-lay-quad">' + cell(it, 0) + cell(it, 1) + cell(it, 2) + cell(it, 3) + '</div>';
    } else {
      var e0 = imgAt(it, 0);
      html = '<div class="dzc-lay dzc-lay-single">' +
        art(e0, 'dzc-pv is-on', it.graphic) +
        '<a class="dzc-fill" href="' + esc(e0.href || it.href || '#') + '" aria-label="' + esc(it.name) + '"></a>' +
        (it.badge ? '<span class="dzc-newbadge is-show"><i>&#9670;</i> ' + esc(it.badge) + '</span>' : '') +
        '<span class="dzc-cta">Shop now &rarr;</span>' +
        '<span class="dzc-hovcta"><span>Shop ' + esc(it.name) + '</span></span>' +
        '<div class="dzc-pcap">' +
        (it.kicker ? '<div class="dzc-k">' + esc(it.kicker) + '</div>' : '') +
        '<div class="dzc-t">' + esc(it.name) + '</div></div></div>';
    }
    plate.setAttribute('data-layout', layout);
    plate.innerHTML = html;
    if (window.DZC_COSMOS) window.DZC_COSMOS.mount(plate);
  }
  /* The hover-OFF state is the neutral placeholder — never an item's image.
     Showing an item on open made the panel look like that item was selected
     when it was not. No caption, no CTA and no link: there is nothing to click
     until the shopper actually hovers something. */
  /* An item with nothing to show COLLAPSES the image area instead of parking a
     placeholder there — the panel becomes just the link list. */
  function setMedia(panelName, on) {
    var panel = wrap.querySelector('[data-dzc-panel="' + panelName + '"]');
    if (panel) panel.classList.toggle('dzc-panel--nomedia', !on);
  }
  function hasMedia(it) {
    if (!it) return false;
    if (GRAPHIC_TPL[it.graphic]) return true;
    return !!(it.imgs && it.imgs.length && it.imgs[0] && it.imgs[0].src);
  }
  function renderPlaceholder(panelName) {
    var plate = wrap.querySelector('.dzc-plate[data-dzc-plate="' + panelName + '"]');
    setMedia(panelName, false);
    if (plate) plate.innerHTML = '';
  }

  /* The panel's resting state: its `hero` block if one is configured, otherwise
     the neutral placeholder. Never a list item — a panel opening on some item's
     photo reads as though that item is already selected. */
  function renderHero(panelName) {
    var P = CONFIG[panelName];
    if (P && P.heroKey && P.items[P.heroKey]) { render(panelName, P.heroKey); }
    else { renderPlaceholder(panelName); }
  }

  /* Revert-to-hero, with one deliberate exception: moving the pointer from the
     list ONTO the plate must keep the hovered item, or you could never reach
     the image to click it. So leaving the list only *schedules* a revert, and
     entering the plate cancels it. */
  var revertTimer = null;
  function scheduleRevert(panelName) {
    clearTimeout(revertTimer);
    revertTimer = setTimeout(function () { renderHero(panelName); }, 130);
  }
  function cancelRevert() { clearTimeout(revertTimer); }

  var pl = wrap.querySelectorAll('[data-dzc-panel]');
  for (var i = 0; i < pl.length; i++) {
    (function (panel) {
      var name = panel.getAttribute('data-dzc-panel');
      var links = panel.querySelectorAll('[data-dzc-pv]');
      for (var j = 0; j < links.length; j++) {
        (function (a) {
          a.addEventListener('mouseenter', function () { cancelRevert(); render(name, a.getAttribute('data-dzc-pv')); });
          a.addEventListener('focus', function () { cancelRevert(); render(name, a.getAttribute('data-dzc-pv')); });
          /* Per-LINK, not per-list. Reverting only when the pointer left the
             whole list meant drifting onto the whitespace between links kept the
             last item on screen — the panel looked stuck on it. Moving link ->
             link is safe: the next mouseenter cancels this before it fires. */
          a.addEventListener('mouseleave', function () { scheduleRevert(name); });
          a.addEventListener('blur', function () { scheduleRevert(name); });
        })(links[j]);
      }
      var list = panel.querySelector('.dzc-plist');
      if (list) list.addEventListener('mouseleave', function () { scheduleRevert(name); });
      var plate = panel.querySelector('.dzc-plate');
      if (plate) {
        /* Holding the item while the pointer is over the image is what keeps it
           clickable — this cancel is the whole reason the revert is deferred. */
        plate.addEventListener('mouseenter', cancelRevert);
        plate.addEventListener('mouseleave', function () { scheduleRevert(name); });
      }
    })(pl[i]);
  }

  /* ------------------------------------------------------------ mobile --- */
  var drawer = document.querySelector('[data-dzc-drawer]');
  var burger = wrap.querySelector('[data-dzc-burger]');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    if (scrim) scrim.classList.add('is-show');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    if (scrim) scrim.classList.remove('is-show');
    document.documentElement.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  if (drawer) {
    var x = drawer.querySelector('[data-dzc-drawer-close]');
    if (x) x.addEventListener('click', closeDrawer);
    var accs = drawer.querySelectorAll('[data-dzc-acc]');
    for (var k = 0; k < accs.length; k++) {
      (function (acc) {
        var btn = acc.querySelector('.dzc-acc__btn');
        var body = acc.querySelector('.dzc-acc__body');
        if (!btn || !body) return;
        btn.addEventListener('click', function () {
          var willOpen = !acc.classList.contains('is-open');
          /* EXCLUSIVE accordion: opening one section closes the others. With
             all three able to sit open at once the list grew past the fold and
             you had to scroll down to reach the section you had just tapped. */
          if (willOpen) {
            for (var m = 0; m < accs.length; m++) {
              if (accs[m] === acc) continue;
              accs[m].classList.remove('is-open');
              var ob = accs[m].querySelector('.dzc-acc__btn');
              var od = accs[m].querySelector('.dzc-acc__body');
              if (ob) ob.setAttribute('aria-expanded', 'false');
              if (od) od.style.maxHeight = '0px';
            }
          }
          acc.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          body.style.maxHeight = willOpen ? (body.scrollHeight + 'px') : '0px';
          /* Keep the section you just opened in view on a small screen. */
          if (willOpen && acc.scrollIntoView) {
            setTimeout(function () {
              var r = acc.getBoundingClientRect();
              if (r.top < 0 || r.top > window.innerHeight * 0.6) acc.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }, 360);
          }
        });
      })(accs[k]);
    }
  }
  if (scrim) scrim.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  window.addEventListener('scroll', syncHeader, { passive: true });
  window.addEventListener('resize', syncHeader, { passive: true });
  syncHeader();
})();


/* ==========================================================================
   HEADER SEARCH OVERLAY

   Open/close only. All the searching is Dawn's <predictive-search>, which is
   why the markup in dzc-header.liquid keeps Dawn's exact DOM contract - this
   file deliberately does NOT reimplement fetching, caching, keyboard result
   navigation or the live region.

   Three things had to be unblocked before the overlay could work at all, and
   all three were pre-existing breakage, not new:

     1. predictive-search.js queried '.section-header' for its max-height. The
        header rebuild renamed that class, so the query returned null, open()
        threw, and the dropdown never appeared. Fixed in that file.
     2. search-form.js called debounce() in its constructor, but debounce lives
        in global.min.js, which is lazy on non-collection templates - so the
        constructor threw and the element never wired up. Fixed in that file.
     3. predictive-search.js is itself lazy (layout/theme.liquid). It is woken
        here on first open, via the same promoteInOrder() the PDP size-click fix
        uses. findLazy() skips tags that already carry src, so waking it twice
        is a no-op and customElements.define() is never called twice.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-dzc-search]');
  if (!root) return;

  var sheet = root.querySelector('[data-dzc-search-sheet]');
  var scrim = root.querySelector('[data-dzc-search-scrim]');
  var input = root.querySelector('.dzc-srch__input');
  var openers = document.querySelectorAll('[data-dzc-search-open]');
  var lastFocus = null;
  var woken = false;
  var isOpen = false;

  function focusInput() {
    if (!input) return;
    try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); }
  }

  function focusables() {
    return Array.prototype.filter.call(
      sheet.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; }
    );
  }

  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;

    root.removeAttribute('hidden');
    /* Force a reflow between display and the class, or the transition is
       skipped entirely and the panel snaps into place. */
    void root.offsetWidth;
    root.classList.add('is-open');

    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });

    /* Focus immediately - do not wait for the lazy script. Typing before
       predictive-search.js lands still works: the input keeps the characters
       and the first onChange after it upgrades reads input.value.

       This call MUST stay synchronous inside the click handler: iOS Safari
       only raises the keyboard for a focus() that runs in the user-gesture
       task. The rAF below is a retry for the case where the element was not
       yet focusable, not a replacement - deferring the first call outright
       is what breaks the keyboard on iPhone. */
    focusInput();
    requestAnimationFrame(function () {
      if (isOpen && document.activeElement !== input) focusInput();
    });

    if (!woken && window.dzcPromote) {
      woken = true;
      window.dzcPromote(['global.min.js', 'predictive-search.js']);
    }
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

    /* Take it out of the a11y tree once the fade is done. Guarded by isOpen so
       a reopen during the 280ms transition does not hide the panel underneath
       the user. */
    setTimeout(function () { if (!isOpen) root.setAttribute('hidden', ''); }, 300);

    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { lastFocus.focus(); } }
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); isOpen ? close() : open(); });
  });

  var closeBtn = root.querySelector('[data-dzc-search-close]');
  if (closeBtn) closeBtn.addEventListener('click', close);
  if (scrim) scrim.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;

    if (e.key === 'Escape') {
      /* Stop here so the header's own Escape handler does not also fire. */
      e.stopPropagation();
      close();
      return;
    }

    if (e.key !== 'Tab') return;

    /* Focus trap. The panel is a dialog while it is open, so Tab must not walk
       out into the page behind the scrim. */
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];

    if (!sheet.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }, true);

  /* A result link navigates; close first so the panel is not mid-fade if the
     browser restores this page from bfcache. */
  root.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (a) close();
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted && isOpen) close(); });
})();
